export function findLowestPrice(variants) {
  if (!variants.length) return {};

  let lowest_price_variant = {
    price: null
  };
  variants.forEach((variant) => {
    if (
      parseInt(variant.compareAtPrice.amount) <
        parseInt(lowest_price_variant.compareAtPrice) ||
      lowest_price_variant.compareAtPrice === null
    ) {
      lowest_price_variant = variant;
    }
  });

  return lowest_price_variant?.compareAtPrice
    ? lowest_price_variant
    : variants[0];
}

export function findBiggestDiscount(variants, campaign) {
  if (!variants.length) return {};
  let msg = '';
  const discountType = campaign.discount_tag.discount_type;
  const variantDiscountArr = [];

  if (discountType == 'Percentage Amount') {
    //for each variant calculate percentage off
    variants.forEach((variant) => {
      variantDiscountArr.push(
        Math.floor(
          100 - (variant?.price?.amount / variant?.compareAtPrice?.amount) * 100
        )
      );
    });

    //if percentage off is same for each variant, set message to XX% OFF, otherwise set to highest amount of UP TO XX% OFF
    if (variantDiscountArr.every((val, _, arr) => val === arr[0])) {
      if (variantDiscountArr[0] > 0) {
        msg = `${variantDiscountArr[0]}% OFF`;
      } else {
        msg = '';
      }
    } else {
      msg = `UP TO ${Math.max(...variantDiscountArr)}% OFF`;
    }
  } else {
    //for each variant calculate dollar amount off
    variants.forEach((variant) => {
      variantDiscountArr.push(
        Math.floor(variant?.compareAtPrice?.amount - variant?.price?.amount)
      );
    });

    //if dollars off is same for each variant, set message to $XX OFF, otherwise set to highest amount of UP TO $XX OFF
    if (variantDiscountArr.every((item, _, arr) => item === arr[0])) {
      if (variantDiscountArr[0] > 0) {
        msg = `$${variantDiscountArr[0]} OFF`;
      } else {
        msg = '';
      }
    } else {
      msg = `UP TO $${Math.max(...variantDiscountArr)} OFF`;
    }
  }

  return msg;
}

export function buildCopyMsg(options, biggest_discount) {
  const type = options?.copy_type ? options.copy_type.toLowerCase() : 'dollar';
  if (type === 'custom') {
    return options.custom_copy.badge_copy;
  }

  const current_options = options ? options[`${type}_copy`] : null;
  const first = current_options?.badge_copy ? current_options.badge_copy : '';
  const amount = biggest_discount[type];
  const last = current_options?.badge_copy_secondary
    ? current_options.badge_copy_secondary
    : '';

  let msg = `${first} ${amount} ${last}`;
  if (!first && !last) {
    msg = `UP TO ${amount} OFF`;
  }

  return msg;
}

export function getGWPData(campaign, uid) {
  if (campaign && campaign.gifts_with_purchase) {
    // check if there is a product offered as a gift, otherwise return null
    if (campaign.gifts_with_purchase.gwp_productConnection?.edges.length == 0) {
      return null;
    } else if (campaign.gifts_with_purchase?.eligible_products?.length) {
      // check if current product is eligible for gift with purchase
      const eligible = campaign.gifts_with_purchase.eligible_products.find(
        (ep) => {
          return (
            ep.product_eligible_for_gwpConnection?.edges[0]?.node?.system
              ?.uid === uid
          );
        }
      );

      if (eligible) {
        return {
          eligible
        };
      }
    }
  }

  return null;
}
